<div class="alert alert-success content" role="alert" >
    <h1>Logout successful</h1>
    <p>You have successfully logged out of the Nederman NUM App.</p>

    <p>For security reasons, exit your browser.</p>
</div>